import React from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import discomService from "../../../components/Services/discom.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";

const EditEnergyConsumption = ({
 editCell,
 handleCloseEditCellModal,
 getEnergyConsumptionCurve,
}) => {
  console.log(editCell)
 const initialValues = {
  consumption: editCell?.item?.id && (editCell?.item?.quantity>=0 ? "1" : "2"),
  quantity: editCell?.item?.id && Math.abs(editCell?.item?.quantity),
 };
 const validationSchema = Yup.object().shape({
  quantity: Yup.string().required("Required Field"),
  consumption: Yup.string().required("Please Select "),
 });

 const numberInputOnWheelPreventChange = (e) => {
    e.target.blur();
    // Prevent the page/container scrolling
    e.stopPropagation();
    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
     e.target.focus();
    }, 0);
   };

 return (
  <div>
   <Modal
    show={Boolean(editCell)}
    onHide={() => handleCloseEditCellModal()}
    className="modal"
    size="md"
    centered
   >
    <Modal.Header closeButton>
     <Modal.Title>Edit : {editCell?.item?.month}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
     <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
       let reqBody = {
        discomId: editCell?.discomId,
        month: editCell?.item?.month,
        quantity:
         values?.consumption == "1" ? values?.quantity : -values?.quantity,
       };
       discomService.saveEnergyCunsumtionMonthWise(reqBody).then((response) => {
        if (response?.data?.code === 200) {
         getEnergyConsumptionCurve();
         handleCloseEditCellModal();
         toast.success(response?.data?.message, toastProperties);
        }
       });
    console.log("requestBody==>",reqBody)
      }}
     >
      {({ values, setFieldValue, setFieldTouched, setValues }) => {
       return (
        <Form>
         <div className="login-box-vh-center">
          <div className="login-box">
           <div className="p-4 gap-3">
            <div>
             <label htmlFor="amount">Consumption*</label>
             <div className="d-flex gap-3">
              <div className="form-check-flex">
               <Field
                className="form-check-input"
                type="radio"
                name="consumption"
                value={1}
                id="consumption1"
                checked={1 == values.consumption}
               />
               <label className="form-check-label" htmlFor="consumption1">
                Consumption(+)
               </label>
              </div>
              <div className="form-check-flex">
               <Field
                className="form-check-input"
                type="radio"
                name="consumption"
                value={2}
                id="consumption2"
                checked={2 == values.consumption}
               />
               <label className="form-check-label" htmlFor="consumption2">
                Consumption(-)
               </label>
              </div>
             </div>
             <ErrorMessage
              name="consumption"
              className="text-danger"
              component="div"
             />
            </div>
            <div className="mt-4">
             <label htmlFor="againstAmount">Quantity*</label>
             <Field
              type="number"
              onWheel={numberInputOnWheelPreventChange}
              className="custom-input no-spinner"
              placeholder=""
              name="quantity"
              onKeyDown={(e) => {
               if (
                e.key === "+" ||
                e.key === "-" ||
                e.key === "e" ||
                e.key === "ArrowUp" ||
                e.key === "ArrowDown"
               ) {
                e.preventDefault();
               }
              }}
             />
             <ErrorMessage
              name="quantity"
              component="div"
              className="text-danger"
             />
            </div>
            <div className="mt-4 d-flex  justify-content-center">
             <button type="submit" className="btn btn-approve">
              Submit
             </button>
            </div>
           </div>
          </div>
         </div>
        </Form>
       );
      }}
     </Formik>
    </Modal.Body>
   </Modal>
  </div>
 );
};

export default EditEnergyConsumption;
